export const EVENT_BOOKING_LOAD_ERROR_MESSAGE =
  "Failed to load booking details.";
